<!--材料预约列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCode"
          v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
          selectType="selectAssemble"
          :disabled="isDisableOrganization"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
        />
        <global-select
          slot="workShift"
          :value.sync="queryParams.workShift"
          :selectData="workShiftList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <create-modal ref="createModalRef" @refresh="handleOk" />
        <a-button v-hasPermi="['bom:bomAttendanceModeCc:save']" type="primary" :loading="loading" @click="onCreate">新增</a-button>
        <a-button v-hasPermi="['bom:bomAttendanceModeCc:remove']" :loading="loading" @click="onDelete">删除</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <!-- 模式名称 -->
          <template slot="modeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.modeName" placeholder="请输入" :maxLength="40" />
          </template>
          <!-- 工作时间 -->
          <template slot="workStartTime" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ `${text} - ${record.workEndTime}` }}</span>
            <div v-else>
              <a-time-picker
                v-model="record.workStartTime"
                :default-value="moment('08:45', 'HH:mm')"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
              />
              <a-time-picker
                v-model="record.workEndTime"
                :default-value="moment('18:15', 'HH:mm')"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
              />
            </div>
          </template>
          <!-- 出勤班次  -->
          <template slot="workShiftName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              v-model="record.workShift"
              :selectData="workShiftList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
          </template>
          <!-- 备注 -->
          <template slot="remark" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.remark" placeholder="请输入" :maxLength="100" />
          </template>
          <span slot="operation" slot-scope="text">
            <a
              v-if="(!isEdit || currentId !== text.record.id)"
              v-hasPermi="['bom:bomAttendanceModeCc:save']"
              @click="handleEdit(text.record)"
            >编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'

import {
  apiAttendanceModeList,
  apiAttendanceModeUpdate,
  apiAttendanceModeDel
 } from '@/api/mes/productionPrepare/attendanceMode'
import createModal from './components/create-modal.vue'

import { mapState } from 'vuex'
import moment from 'moment';

export default {
  name: 'AttendanceMode',
  components: { createModal },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  data() {
    return {
      loading: false, // 请求loading
      isEdit: false,
      currentId: '',
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiAttendanceModeList, false),
        pageCurrent: true
      },
      workShiftList: [], // 业务类型列表
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        workShift: undefined,
        modeCode: undefined,
        modeName: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '出勤班次', decorator: ['workShift'], type: 'workShift' },
        { label: '模式编码', decorator: ['modeCode'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '模式名称', decorator: ['modeName'], type: 'input', attrs: { placeholder: '请输入' } }],
      // 表格字段
      columns: [
        { title: '模式编码', dataIndex: 'modeCode', align: 'center', width: 140 },
        { title: '模式名称', dataIndex: 'modeName', scopedSlots: { customRender: 'modeName' }, align: 'center', width: 140 },
        { title: '所属加工组织', dataIndex: 'organizationName', align: 'center', width: 200 },
        { title: '工作时间', dataIndex: 'workStartTime', scopedSlots: { customRender: 'workStartTime' }, align: 'center', width: 340 },
        { title: '出勤班次', dataIndex: 'workShiftName', scopedSlots: { customRender: 'workShiftName' }, align: 'center', width: 140 },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, align: 'center', width: 140 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('WORK_SCHEDULE', { lookupType: 'WORK_SCHEDULE', current: 1, pageSize: 999 }, 'workShiftList')
    this.queryParams.organizationCode = this.organizationCodeOrigin;
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    moment,
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    },
    // 保存
    handleSave(record) {
      if (!record?.modeName) {
        this.$message.warning('请输入模式名称')
        return
      }
      if (!record?.workStartTime || !record?.workEndTime) {
        this.$message.warning('请输入工作时间')
        return
      }
      if (!record?.workShift) {
        this.$message.warning('请输入出勤班次')
        return
      }
      this.loading = true

      apiAttendanceModeUpdate(record)
        .then((res) => {
          if (res?.code === 200) {
            this.$message.success('编辑成功')
            this.handleOk(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.organizationCodeOrigin,
        workShift: undefined,
        modeCode: undefined,
        modeName: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 新增物料
    onCreate() {
      this.$refs.createModalRef.show()
    },
    // 删除
    onDelete() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否删除勾选单据？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const codes = self.selectedRows.map(item => item.modeCode)
          apiAttendanceModeDel(codes).then(res => {
            if (res?.code === 200) {
              self.$message.success(res?.msg || '操作成功')
              self.handleOk()
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.pub-select {
  /deep/ .ant-select {
    width: 100%;
  }
}
</style>
